import React, { useState, useEffect, Fragment, useRef } from "react"
import ElementsButton from "./ElementsButton"
import ListButton from "./ListButton"
import { useSelector } from "react-redux"
import ReactTagInput from "@pathofdev/react-tag-input"
import Tooltip from "@material-ui/core/Tooltip"
import { Typography } from "@material-ui/core"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { getMonth, getYear } from "date-fns"
import range from "lodash/range"
import { sourceHelper } from "../../helpers/sourceHelper"
import ColorPicker from "../common/ColorPicker"
import { Dropdown, DropdownButton } from "react-bootstrap"
import BubbleTag from "../common/BubbleTag"
import TagsFilterDropdown from "../common/TagsFilterDropdown"
import { getSortedListByDate, isDateValidated } from "../../utils"

const FiltersElementsBuild = ({
	viewItemsBtn,
	setViewItemsBtn,
	elementsFilter,
	saveElementsFilter,
	createFilter,
	filtersButton,
	setFiltersButton,
	setFilterList,
	filterList,
	popups,
	setPopups,
	setRequestNewDateSearch,
	setNeedToFilter,
	setFilterDate,
	savedTags,
	setSavedTags,
	savedTagsExclude,
	setSavedTagsExclude,
	counterDocs,
	setCounterDocs,
	applyFilterSource,
}) => {
	/* ******************* REDUX STORE ******************* */
	//Redux actions
	const conceptDocs = useSelector((state) => state.buildconcept.concept_docs)
	const sourceFilter = useSelector((state) => state.buildconcept.sourceFilter)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Filetypes Filter
	const [showFiletypesFilter, setShowFiletypesFilter] = useState(false)
	// Create custom Tags (Color Picker)
	const [showColorPicker, setShowColorPicker] = useState(false)

	const [datepicker, setDatepicker] = useState({
		startDate: "",
		endDate: "",
		invalidMessage: "",
	})
	// FILTERS
	const [showFilters, setShowFilters] = useState(false)
	// Tags input state
	const [tags, setTags] = useState(savedTags)
	// TagsExclude input state
	const [tagsExclude, setTagsExclude] = useState(savedTagsExclude)
	// Date Picker
	const [startDate, setStartDate] = useState(filtersButton.fromDate)
	const [endDate, setEndDate] = useState(filtersButton.toDate)
	const [numActiveFilters, setNumActiveFilter] = useState(6)
	// Date Sort Filter
	const [dateSort, setDateSort] = useState("desc")
	const [buildDocumentsList, setBuildDocumentslist] = useState({ count: 0, data: [] })
	const [filterCustomTags, setFilterCustomTags] = useState([])
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		setBuildDocumentslist(conceptDocs)
		return
		// eslint-disable-next-line
	}, [conceptDocs])

	useEffect(() => {
		saveElementsFilter({
			...elementsFilter,
			date: dateSort,
		})

		if (buildDocumentsList.data.length > 0) {
			let auxDocList = buildDocumentsList.data
			if (auxDocList.length > 0) {
				auxDocList.forEach(function (item, i) {
					if (item.hasOwnProperty("tagged_date") && item.tagged_date !== null && item.tagged_date !== undefined) {
					} else {
						item["tagged_date"] = item.creation_time
						auxDocList[i] = item
					}
				})
			}
			auxDocList = getSortedListByDate(auxDocList, dateSort)
			setBuildDocumentslist({
				...buildDocumentsList,
				data: auxDocList,
			})
		}
		return

		// eslint-disable-next-line
	}, [dateSort])

	useEffect(() => {
		let activeFilters = 0
		Object.keys(filterList).map((key) => {
			if (filterList[key] === true) {
				activeFilters = activeFilters + 1
			}
		})
		setNumActiveFilter(activeFilters)
	}, [filterList])

	useEffect(() => {
		setFilterDate({
			start: filtersButton.fromDate,
			end: filtersButton.toDate,
		})

		let auxFromDate = filtersButton.fromDate === "" ? null : new Date(filtersButton.fromDate)
		let auxToDate = filtersButton.toDate === "" ? null : new Date(filtersButton.toDate)

		setDatepicker({
			startDate:
				auxFromDate === null
					? ""
					: `${auxFromDate.getFullYear()}-${("0" + (auxFromDate.getMonth() + 1)).slice(-2)}-${("0" + auxFromDate.getDate()).slice(
							-2
					  )}`,
			endDate:
				auxToDate === null
					? ""
					: `${auxToDate.getFullYear()}-${("0" + (auxToDate.getMonth() + 1)).slice(-2)}-${("0" + auxToDate.getDate()).slice(-2)}`,
		})
	}, [filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		setFiltersButton({
			...filtersButton,
			searchWord: [tags],
		})
		return
		// eslint-disable-next-line
	}, [tags])

	useEffect(() => {
		if (!showFilters) {
			checkDateFilterChanges()
		}
	}, [showFilters])

	useEffect(() => {
		setFiltersButton({
			...filtersButton,
			fromDate: startDate,
			toDate: endDate,
		})
	}, [startDate, endDate])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// Filter by priority
	const mainTagClick = (tag_id) => {
		saveElementsFilter({
			coloursFilter: tag_id,
		})
	}

	const submitFiltersForm = (e) => {
		e.preventDefault()
		createFilter(filtersButton)
	}

	const updateFilters = (e) => {
		setFiltersButton({
			...filtersButton,
			[e.target.name]: !filtersButton[e.target.name],
		})
	}

	// const updateFilters = e => {
	//     var auxVal=(e.target.value);
	//     if (auxVal==='on'){
	//         auxVal=true;
	//     }
	//     setFiltersButton({
	//         ...filtersButton,
	//         [e.target.name]: auxVal
	//     })
	// };

	// const updateDateFilters = (e) => {
	//     setFiltersButton({
	//         ...filtersButton,
	//         [e.target.name]: new Date(e.target.value)
	//     })
	// };

	const updateDateFilters = (e) => {
		setDatepicker({
			...datepicker,
			invalidMessage: "",
			[e.target.name]: e.target.value,
		})
	}

	const applyDateFilter = (e) => {
		e.preventDefault()
		const date = {
			fromDate: datepicker.startDate === "" ? datepicker.startDate : new Date(datepicker.startDate),
			toDate: datepicker.endDate === "" ? datepicker.endDate : new Date(datepicker.endDate),
		}
		let invalidMessage = ""
		if ((date.fromDate === "" || isDateValidated(date.fromDate)) && (date.toDate === "" || isDateValidated(date.toDate))) {
			if (date.fromDate > date.toDate && date.toDate !== "") {
				invalidMessage = "*Atention! Start date can't be greater than End date"
			} else if (date.fromDate === "" && date.toDate === "") {
				invalidMessage = "Please enter a date!"
			} else {
				setFiltersButton({
					...filtersButton,
					fromDate: date.fromDate,
					toDate: date.toDate,
				})
				setShowFilters(false)
			}
		} else {
			invalidMessage = "Please enter a valid date!"
		}
		setDatepicker({
			...datepicker,
			invalidMessage,
		})
	}

	const resetDateFilters = (e) => {
		e.preventDefault()
		setFiltersButton({
			...filtersButton,
			fromDate: "",
			toDate: "",
		})

		setDatepicker({
			startDate: "",
			endDate: "",
		})

		setStartDate("")
		setEndDate("")
	}

	const requestRefreshContentFilterType = () => {}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (showFiletypesFilter === true) {
					requestRefreshContentFilterType()
				}
				if (showColorPicker === true) {
					requestRefreshContentFilterType()
				}
				if (ref.current && !ref.current.contains(event.target)) {
					//alert("You clicked outside of me!");
					setShowFilters(false)
					if (showFiletypesFilter === true) {
						requestRefreshContentFilterType()
					}
					setShowFiletypesFilter(false)
					if (showColorPicker === true) {
						requestRefreshContentFilterType()
					}
					setShowColorPicker(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const checkDateFilterChanges = () => {
		if (filtersButton.fromDate !== "") {
			if (sourceFilter.fromDate === "") {
				//Last search includes everything in from, so there is no problem
			} else {
				if (new Date(filtersButton.fromDate) < new Date(sourceFilter.fromDate)) {
					//need to research
					setRequestNewDateSearch(true)
					return
				}
			}
		}
		if (filtersButton.toDate !== "") {
			if (sourceFilter.toDate === "") {
				//Last search includes everything in from, so there is no problem
			} else {
				if (new Date(filtersButton.toDate) > new Date(sourceFilter.toDate)) {
					//need to research
					setRequestNewDateSearch(true)
					return
				}
			}
		}

		if (sourceFilter.fromDate !== "" && filtersButton.fromDate === "") {
			setRequestNewDateSearch(true)
			return
		}

		if (sourceFilter.toDate !== "" && filtersButton.toDate === "") {
			setRequestNewDateSearch(true)
			return
		}
	}

	const updateCurrentTags = (newTags) => {
		setSavedTags(newTags)
	}

	const updateCurrentTagsExclude = (newTagsExclude) => {
		setSavedTagsExclude(newTagsExclude)
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const wrapperRef = useRef(null)
	const initial_date = window._env_.REACT_APP_INITIAL_DATE_FILTER
	const years = range(initial_date, getYear(new Date()) + 1, 1)
	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	]
	/* ******************* END VARIABLES ******************* */

	/* ******************* FUNCTION CALL POST INITIALIZATION ******************* */
	useOutsideAlerter(wrapperRef)
	/* ******************* END FUNCTION CALL POST INITIALIZATION ******************* */

	return (
		<Fragment>
			<div className="container-fluid">
				<div
					className="col-12 divFilters"
					ref={wrapperRef}
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "flex-end",
						//paddingRight: "70px", paddingTop: "37px"
					}}
				>
					<ListButton viewItemsBtn={viewItemsBtn} setViewItemsBtn={setViewItemsBtn} setNeedToFilter={setNeedToFilter} />
					<Tooltip
						title={
							<Fragment>
								<Typography color="inherit">WordCloud</Typography>
								{"View the concepts words cloud."}
							</Fragment>
						}
						placement="bottom"
						arrow
					>
						<button
							onClick={(e) => {
								e.preventDefault()
								setViewItemsBtn("cloud")
								setNeedToFilter(true)
							}}
							className={
								viewItemsBtn === "cloud"
									? "btn btn-primary  btnViewsFilterBuild ml-2 btn-small-filter"
									: "btn btn-outline-primary  btnViewsFilterBuild ml-2 btn-small-filter"
							}
						>
							<i className="bi bi-cloud"></i>
						</button>
					</Tooltip>
					<ElementsButton
						viewItemsBtn={viewItemsBtn}
						setViewItemsBtn={setViewItemsBtn}
						setNeedToFilter={setNeedToFilter}
						counterDocs={counterDocs}
						setCounterDocs={setCounterDocs}
					/>
				</div>
				{/* <div className="col-5 divBlockFilterElements divBlockFilterElements_Build" style={{ marginTop: "0px" }}>
						<div className="col-12">
							<div id="numDocs" className="col-6 divBlock">
								<span data-cy="numdocs">
									<strong>{buildDocumentsList.count > 0 ? buildDocumentsList.count : 0}</strong> results from dataset
								</span>
							</div>

							<div className="col-4 divBlock divHighlightsTypes">
								<div id="filters" className="col-2 divBlock  filter_concept">
									<a
										href="/#"
										onClick={(e) => {
											e.preventDefault()
											setShowFilters(!showFilters)
											setShowFiletypesFilter(false)
										}}
										data-cy="filters"
									>
										Highlights
									</a>
									<div className={showFilters ? "show divFiletypes" : "hide"}>
										<div className="col-3">
											<div className="col-12 d-flex mb-3">
												<form className="col-12 divBlock" onSubmit={submitFiltersForm}>
													<div className="col-12 divBlock">
														<h5>Highlight</h5>
													</div>
													<div className="col-12 divBlock form-switch mt-10">
														<div className="col-6 divBlock">
															<label className="form-check-label">Dates</label>
														</div>
														<div className="col-6 divBlock pl-3">
															<input
																name="dates"
																className="form-check-input"
																type="checkbox"
																id="flexSwitchCheckChecked_date"
																defaultChecked={filtersButton.dates}
																onChange={updateFilters}
															/>
														</div>
													</div>
													<div className="col-12 divBlock form-switch mt-10">
														<div className="col-6 divBlock">
															<label className="form-check-label">Concepts</label>
														</div>
														<div className="col-6 divBlock pl-3">
															<input
																name="concepts"
																className="form-check-input"
																type="checkbox"
																id="flexSwitchCheckChecked_concept"
																defaultChecked={filtersButton.concepts}
																onChange={updateFilters}
															/>
														</div>
													</div>
													<div className="col-12 divBlock form-switch mt-10">
														<div className="col-6 divBlock">
															<label className="form-check-label">Emails</label>
														</div>
														<div className="col-6 divBlock pl-3">
															<input
																name="emails"
																className="form-check-input"
																type="checkbox"
																id="flexSwitchCheckChecked_email"
																defaultChecked={filtersButton.emails}
																onChange={updateFilters}
															/>
														</div>
													</div>
													<div className="col-12 divBlock form-switch mt-10">
														<div className="col-6 divBlock">
															<label className="form-check-label">Specific word</label>
														</div>
														<div className="col-6 divBlock pl-3">
															<input
																name="specificWord"
																className="form-check-input"
																type="checkbox"
																id="flexSwitchCheckChecked_word"
																defaultChecked={filtersButton.specificWord}
																onChange={updateFilters}
															/>
														</div>
													</div>
													<div className="col-12 divBlock form-control mt-10">
														<div data-cy="specific_word" className="col-12 divBlock pl-3">
															<ReactTagInput
																tags={tags}
																placeholder="Type and press enter"
																maxTags={10}
																editable={true}
																readOnly={false}
																removeOnBackspace={true}
																onChange={(newTags) => {
																	if (newTags !== "") {
																		updateCurrentTags(newTags)
																	}
																	setTags(newTags)
																}}
															/>
														</div>
														<div className="col-12 divBlock">
															<small>*Remember to press enter after type a word</small>
														</div>
													</div>
													<div className="col-12 divBlock form-switch mt-10" style={{ display: "none" }}>
														<div className="col-6 divBlock">
															<label className="form-check-label">Remove specific word</label>
														</div>
														<div className="col-6 divBlock pl-3">
															<input
																name="specificWordExclude"
																className="form-check-input"
																type="checkbox"
																id="flexSwitchCheckChecked_word"
																onChange={updateFilters}
															/>
														</div>
													</div>
													<div className="col-12 divBlock form-control mt-10" style={{ display: "none" }}>
														<div className="col-12 divBlock pl-3">
															<ReactTagInput
																tags={tagsExclude}
																placeholder="Type and press enter"
																maxTags={10}
																editable={true}
																readOnly={false}
																removeOnBackspace={true}
																//onChange={(newTagsExclude) => setTagsExclude(newTagsExclude)}
																onChange={(newTagsExclude) => {
																	if (newTagsExclude !== "") {
																		updateCurrentTagsExclude(newTagsExclude)
																	}
																	setTagsExclude(newTagsExclude)
																}}
															/>
														</div>
														<div className="col-12 divBlock">
															<small>*Remember to press enter after type a word</small>
														</div>
													</div>
													<div className="col-12 divBlock mt-5">
														<h5>Search between dates</h5>
													</div>
													<div className="col-12 divBlock mt-10">
														<div className="col-2 divBlock">
															<label className="form-label">From</label>
														</div>
														<div data-cy="from_date" className="col-2 divBlock"> */}
				{/* ************* DATEPICKER ************* */}
				{/* <DatePicker
                                                                dateFormat="dd/MM/yyyy"
                                                                renderCustomHeader={({
                                                                    date,
                                                                    changeYear,
                                                                    changeMonth,
                                                                    decreaseMonth,
                                                                    increaseMonth,
                                                                    prevMonthButtonDisabled,
                                                                    nextMonthButtonDisabled,
                                                                }) => (
                                                                    <div
                                                                    style={{
                                                                        margin: 10,
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                    }}
                                                                    >
                                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                                        {"<"}
                                                                    </button>
                                                                    <select
                                                                        style={{
                                                                            width: '50px',
                                                                            paddingLeft: '4px',
                                                                        }}
                                                                        value={getYear(date)}
                                                                        onChange={({ target: { value } }) => changeYear(value)}
                                                                    >
                                                                        {years.map((option) => (
                                                                        <option key={option} value={option}>
                                                                            {option}
                                                                        </option>
                                                                        ))}
                                                                    </select>
                                                            
                                                                    <select
                                                                        style={{
                                                                            width: '80px',
                                                                            paddingLeft: '6px',
                                                                        }}
                                                                        value={months[getMonth(date)]}
                                                                        onChange={({ target: { value } }) =>
                                                                        changeMonth(months.indexOf(value))
                                                                        }
                                                                    >
                                                                        {months.map((option) => (
                                                                        <option key={option} value={option}>
                                                                            {option}
                                                                        </option>
                                                                        ))}
                                                                    </select>
                                                            
                                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                                        {">"}
                                                                    </button>
                                                                    </div>
                                                                )}
                                                                
                                                                selected={filtersButton.fromDate} 
                                                                //onChange={(date) => setStartDate(date)}
                                                                onChange={(date)=>{
                                                                    setStartDate(date);
                                                                    //updateDateFilters();
                                                                }}
                                                                //isClearable={true}
                                                            /> */}
				{/* ************* END DATEPICKER ************* */}
				{/* <input
																name="startDate"
																className="form-input"
																type="date"
																id="datePickerFrom"
																onChange={updateDateFilters}
																value={datepicker.startDate}
															/>
														</div>
													</div>
													<div className="col-12 divBlock mt-10">
														<div className="col-2 divBlock">
															<label className="form-label">To</label>
														</div>
														<div data-cy="to_date" className="col-2 divBlock"> */}
				{/* ************* DATEPICKER ************* */}
				{/* <DatePicker
                                                                dateFormat="dd/MM/yyyy"
                                                                renderCustomHeader={({
                                                                    date,
                                                                    changeYear,
                                                                    changeMonth,
                                                                    decreaseMonth,
                                                                    increaseMonth,
                                                                    prevMonthButtonDisabled,
                                                                    nextMonthButtonDisabled,
                                                                }) => (
                                                                    <div
                                                                    style={{
                                                                        margin: 10,
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                    }}
                                                                    >
                                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                                        {"<"}
                                                                    </button>
                                                                    <select
                                                                        style={{
                                                                            width: '50px',
                                                                            paddingLeft: '4px',
                                                                        }}
                                                                        value={getYear(date)}
                                                                        onChange={({ target: { value } }) => changeYear(value)}
                                                                    >
                                                                        {years.map((option) => (
                                                                        <option key={option} value={option}>
                                                                            {option}
                                                                        </option>
                                                                        ))}
                                                                    </select>
                                                            
                                                                    <select
                                                                        style={{
                                                                            width: '80px',
                                                                            paddingLeft: '6px',
                                                                        }}
                                                                        value={months[getMonth(date)]}
                                                                        onChange={({ target: { value } }) =>
                                                                        changeMonth(months.indexOf(value))
                                                                        }
                                                                    >
                                                                        {months.map((option) => (
                                                                        <option key={option} value={option}>
                                                                            {option}
                                                                        </option>
                                                                        ))}
                                                                    </select>
                                                            
                                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                                        {">"}
                                                                    </button>
                                                                    </div>
                                                                )} 
                                                                selected={filtersButton.toDate} 
                                                                //onChange={(date) => setEndDate(date)} 
                                                                onChange={(date)=>{
                                                                    setEndDate(date);
                                                                    //updateDateFilters();
                                                                }}
                                                                //isClearable={true}
                                                            /> */}
				{/* ************* END DATEPICKER ************* */}
				{/* <input
																name="endDate"
																className="form-input"
																type="date"
																id="datePickerTo"
																onChange={updateDateFilters}
																value={datepicker.endDate}
															/>
														</div>
													</div>
													{!!datepicker.invalidMessage ? (
														<div className="col-12 divBlock mt-4 d-flex justify-content-center">
															<small style={{ color: "red" }}>{datepicker.invalidMessage}</small>
														</div>
													) : null}
													<div className="col-12 divBlock mt-4 d-flex justify-content-center">
														<div className="col-6 divBlock d-flex justify-content-center">
															<a href="/#" onClick={applyDateFilter} data-cy="apply_dates">
																Apply dates
															</a>
														</div>
														<div className="col-6 divBlock d-flex justify-content-center">
															<a href="/#" onClick={resetDateFilters} data-cy="reset_dates">
																Reset dates
															</a>
														</div>
														<div className="col-6 divBlock hide hidden hidden-important">
															<button
																type="submit"
																className="btn btn-sm btn-outline-primary"
																style={{ float: "right" }}
															>
																Apply
															</button>
														</div>
													</div>
													<div className="col-12 divBlock mt-4 d-flex justify-content-center hidden-important">
														<div className="col-6 divBlock d-flex justify-content-center">
															<button
																className="btn btn-sm btn-outline-primary"
																onClick={(e) => {
																	e.preventDefault()
																	setShowFilters(!showFilters)
																}}
															>
																Apply
															</button>
														</div>
														<div className="col-6 divBlock hide hidden-important">
															<button
																type="submit"
																className="btn btn-sm btn-outline-primary"
																style={{ float: "right" }}
															>
																Apply
															</button>
														</div>
													</div>
												</form>
											</div>
										</div>
									</div>
								</div>
								<div className="col-6 divBlock filter_concept">
									<a
										id="fileTypes"
										href="/#"
										onClick={(e) => {
											e.preventDefault()
											setShowFiletypesFilter(!showFiletypesFilter)
											setShowFilters(false)
										}}
									>
										File types ({numActiveFilters}/{Object.keys(filterList).length})
									</a>
									<div className={showFiletypesFilter ? "show divFiletypes" : "hide"}>
										<div className="col-3">
											<div className="col-12">
												<h5>File types</h5>
											</div>
											<div className="col-12 d-flex mb-3">
												<form className="col-12 divBlock">
													{Object.keys(filterList).map((key, i) => (
														<div className="col-12 divBlock form-switch mt-10" key={`key_filter_${i}`}>
															<div className="col-8 divBlock">
																<label className="form-check-label">
																	{sourceHelper.getHumanValue(key)}
																</label>
															</div>
															<div className="col-4 divBlock pl-3">
																<input
																	className="form-check-input sourceFilterCheck"
																	id={key}
																	type="checkbox"
																	defaultChecked={filterList[key]}
																	onChange={(e) => {
																		setFilterList({ ...filterList, [key]: !filterList[key] })
																	}}
																/>
															</div>
														</div>
													))}

													<div className="col-12 divBlock mt-4 d-flex justify-content-center">
														<div className="col-6 divBlock d-flex justify-content-center">
															<button
																data-cy="apply_button"
																type="submit"
																className="btn btn-sm btn-outline-primary"
																onClick={(e) => {
																	e.preventDefault()
																	applyFilterSource()
																	setShowFiletypesFilter(false)
																}}
															>
																Apply
															</button>
														</div>
													</div>
												</form>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div> */}

				{/* <div className="col-4 divBlock divPriorityBuild">
						<div className="col-12">
							<div id="createCustomTags" className="col-3 divBlock mt-1">
								<a
									id="customTagsBtn"
									data-cy="create_custom_tags_btn"
									href="/#"
									onClick={(e) => {
										e.preventDefault()
										if (showColorPicker === true) {
											requestRefreshContentFilterType()
										}
										setShowColorPicker(!showColorPicker)
										setShowFilters(false)
									}}
								>
									Create tags
								</a>
							</div>
							<div className={showColorPicker ? "show divCreateCustomTags" : "hide"}>
								<div className="col-3">
									<div className="col-12">
										<h5>Create custom tags</h5>
									</div>
									<div className="col-12 mb-3">
										<ColorPicker />
									</div>
								</div>
							</div>
							<BubbleTag elementsFilter={elementsFilter} mainTagClick={mainTagClick} /> */}
				{/* <div className="col-1 divBlock btnColor divColor">
                                <Tooltip title="Important" placement="bottom" arrow>
                                    <button
                                        data-cy="red_btn" 
                                        className= {elementsFilter.coloursFilter === 'red' ? "btn btn-danger  btnRefreshTermsList rounded-pill btnColorFilter" : "btn btn-outline-danger  btnRefreshTermsList rounded-pill btnColorFilter"}
                                        style={{padding: '4px'}}
                                        onClick={redBtnClick}    
                                    >
                                        R
                                    </button>
                                </Tooltip>
                            </div>
                            <div className="col-1 divBlock btnColor divColor">
                                <Tooltip title="Undecided" placement="bottom" arrow>
                                    <button
                                        data-cy="yellow_btn"
                                        className= {elementsFilter.coloursFilter === 'yellow' ? "btn btn-warning  btnRefreshTermsList rounded-pill ml-2 btnColorFilter" : "btn btn-outline-warning  btnRefreshTermsList rounded-pill ml-2 btnColorFilter"} 
                                        style={{padding: '4px'}}
                                        onClick={yellowBtnClick}
                                    >
                                        Y
                                    </button>
                                </Tooltip>
                            </div>
                            <div className="col-2 divBlock btnColor divColor">
                                <Tooltip title="Not important" placement="bottom" arrow>
                                    <button
                                        data-cy="green_btn"
                                        className= {elementsFilter.coloursFilter === 'green' ? "btn btn-success  btnRefreshTermsList rounded-pill ml-2 btnColorFilter" : "btn btn-outline-success  btnRefreshTermsList rounded-pill ml-2 btnColorFilter"} 
                                        style={{padding: '4px'}}
                                        onClick={greenBtnClick}
                                    >
                                        G
                                    </button>
                                </Tooltip>
                            </div> */}
				{/* <div id="selectCustomTags" className="col-2 divBlock mt-1">
								<TagsFilterDropdown tagsApi={tagsApi} mainTagClick={mainTagClick} />
							</div>
						</div>
					</div> */}
				{/* sdsdsdddddddddddddddddddddddddddddddddddddddddddd */}
				{/* <div className="col-3 divBlock divButtonsMobile"> */}
				{/* <div id="date" className="col-1 divBlock">
							<div className="col-12 divBlock min-100">
								<div className="col-4 divBlock mt-1">
									<span>
										<strong>Date</strong>
									</span>
								</div>
								<div className="col-2 divBlock btnArrow mt-1">
									<i
										data-cy="date_sort_down"
										className={
											dateSort === "asc"
												? "bi bi-arrow-down-circle dateIcon"
												: "bi bi-arrow-down-circle-fill dateIcon"
										}
										style={{ cursor: "pointer" }}
										onClick={(e) => {
											setDateSort("desc")
										}}
									></i>
								</div>
								<div className="col-2 divBlock btnArrow mt-1">
									<i
										data-cy="date_sort_up"
										className={
											dateSort === "asc"
												? "bi bi-arrow-up-circle-fill dateIcon ml-2"
												: "bi bi-arrow-up-circle dateIcon ml-2"
										}
										style={{ cursor: "pointer" }}
										onClick={(e) => {
											setDateSort("asc")
										}}
									></i>
								</div>
							</div>
						</div> */}
				{/* <div className="col-6 divBlock buttonsViewsBuild">
							<ListButton viewItemsBtn={viewItemsBtn} setViewItemsBtn={setViewItemsBtn} setNeedToFilter={setNeedToFilter} />
							<Tooltip
								title={
									<Fragment>
										<Typography color="inherit">WordCloud</Typography>
										{"View the concepts words cloud."}
									</Fragment>
								}
								placement="bottom"
								arrow
							>
								<button
									onClick={(e) => {
										e.preventDefault()
										setViewItemsBtn("cloud")
										setNeedToFilter(true)
									}}
									className={
										viewItemsBtn === "cloud"
											? "btn btn-primary  btnViewsFilterBuild ml-2 btn-small-filter"
											: "btn btn-outline-primary  btnViewsFilterBuild ml-2 btn-small-filter"
									}
								>
									<i className="bi bi-cloud"></i>
								</button>
							</Tooltip>
							<ElementsButton
								viewItemsBtn={viewItemsBtn}
								setViewItemsBtn={setViewItemsBtn}
								setNeedToFilter={setNeedToFilter}
								counterDocs={counterDocs}
								setCounterDocs={setCounterDocs}
							/>
						</div>
					</div> */}
			</div>
		</Fragment>
	)
}

export default FiltersElementsBuild
